import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Layouts
import PublicLayout from './layouts/PublicLayout';
import AppLayout from './layouts/AppLayout';

// Public Pages
import HomePage from './pages/public/HomePage';
import TopicIndexPage from './pages/public/TopicIndexPage';
import TopicHubPage from './pages/public/TopicHubPage';
import InsightPage from './pages/public/InsightPage';
import EpisodePage from './pages/public/EpisodePage';
import BrandPage from './pages/public/BrandPage';
import PricingPage from './pages/public/PricingPage';
import JoinPage from './pages/public/JoinPage';

// App Pages
import ProjectsPage from './pages/app/ProjectsPage';
import BrandDashboardPage from './pages/app/BrandDashboardPage';
import InsightWorkspacePage from './pages/app/InsightWorkspacePage';
import EpisodesPage from './pages/app/EpisodesPage';
import BrandSettingsPage from './pages/app/BrandSettingsPage';

// Legacy Keepers
import Auth from './pages/auth/Auth';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import Checkout from './pages/billing/Checkout';
import PaymentSuccess from './pages/billing/PaymentSuccess';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Root redirects to login */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Public Routes */}
        <Route path="/public" element={<PublicLayout />}>
          <Route index element={<HomePage />} />
          
          <Route path="topics" element={<TopicIndexPage />} />
          <Route path="topics/:slug" element={<TopicHubPage />} />
          
          {/* Insight Routes: Hierarchical (Preferred) & Flat (Fallback) */}
          <Route path="topics/:topicSlug/insights/:insightSlug" element={<InsightPage />} />
          <Route path="insights/:insightSlug" element={<InsightPage />} />
          
          <Route path="episodes/:slug" element={<EpisodePage />} />
          
          <Route path="brands/:slug" element={<BrandPage />} />
          
          {/* Pricing Route */}
          <Route path="pricing" element={<PricingPage />} />

          {/* Invite Join Route */}
          <Route path="join" element={<JoinPage />} />
        </Route>

        {/* Auth Routes */}
        <Route path="/login" element={<Auth />} />
        <Route path="/signup" element={<Auth />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        
        {/* Billing Routes (Legacy) */}
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />

        {/* App Routes (Authenticated) */}
        <Route path="/app" element={<AppLayout />}>
          {/* Redirect /app to /app/projects */}
          <Route index element={<Navigate to="projects" replace />} />
          
          <Route path="projects" element={<ProjectsPage />} />
          
          <Route path="brand/:brandSlug/dashboard" element={<BrandDashboardPage />} />
          <Route path="brand/:brandSlug/episodes" element={<EpisodesPage />} />
          <Route path="brand/:brandSlug/settings" element={<BrandSettingsPage />} />
        </Route>

        {/* Workspace Route (Authenticated but maybe distinct layout later, using AppLayout for now) */}
        <Route path="/workspace" element={<AppLayout />}>
            <Route path="episode/:episodeSlug" element={<InsightWorkspacePage />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<div className="p-12 text-center text-xl">404: Page Not Found</div>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
